const sxStyles = {
    avatar: {
        width: "30px",
        height: "30px",
        fontSize: "caption.fontSize",
        textTransform: "uppercase",
        backgroundColor: "#1F3045",
    },
};
export default sxStyles;
//# sourceMappingURL=Avatar.style.js.map